import { PublicNav } from "../components/public/PublicNav";
import { PublicFooter } from "../components/public/PublicFooter";
import { DOCS, LEGAL_LAST_UPDATED, TERMS_VERSION, CONTACT_NOTE } from "../legal/legalContent";

const List = ({ items }) => (
  <ul className="mt-3 space-y-2">
    {items.map((it, i) => (
      <li key={i} className="flex gap-2.5 text-sm text-slate-300 leading-relaxed">
        <span className="mt-2 h-1 w-1 rounded-full bg-amber-400 shrink-0" />{it}
      </li>
    ))}
  </ul>
);

const Section = ({ s }) => (
  <section className="border-t border-white/10 pt-6">
    <h2 className="font-head text-lg font-semibold text-white">{s.h}</h2>
    {s.p?.map((para, i) => <p key={i} className="mt-3 text-sm text-slate-400 leading-relaxed">{para}</p>)}
    {s.list && <List items={s.list} />}
    {s.subsections?.map((sub, i) => (
      <div key={i} className="mt-5">
        <h3 className="font-head text-base font-semibold text-slate-200">{sub.h}</h3>
        {sub.p?.map((para, j) => <p key={j} className="mt-2 text-sm text-slate-400 leading-relaxed">{para}</p>)}
        {sub.list && <List items={sub.list} />}
      </div>
    ))}
    {s.after?.map((para, i) => <p key={i} className="mt-3 text-sm text-slate-500 leading-relaxed">{para}</p>)}
  </section>
);

export default function LegalPage({ doc }) {
  const data = DOCS[doc] || DOCS.terms;
  return (
    <div className="min-h-screen bg-obsidian text-slate-100">
      <PublicNav />
      <main className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 pt-32 pb-24" data-testid={`legal-${data.key}`}>
        <h1 className="font-head text-3xl sm:text-4xl font-extrabold tracking-tight">{data.title}</h1>
        <p className="mt-3 text-slate-400">{data.intro}</p>
        <p className="mt-4 mono-label text-slate-500" data-testid="legal-meta">
          Versión {TERMS_VERSION} · Última actualización: {LEGAL_LAST_UPDATED}
        </p>

        <div className="mt-10 space-y-6">
          {data.sections.map((s, i) => <Section key={i} s={s} />)}
        </div>

        <p className="mt-12 text-xs text-slate-600">{CONTACT_NOTE}</p>
      </main>
      <PublicFooter />
    </div>
  );
}
